// SSO redirects to the customer portal. avatar-web has no embedded login
// form — when the user isn't authenticated we bounce them to the portal's
// /login (or /logout) with a `return_to` query.
//
// The SPA stays portal-agnostic: we navigate to same-origin /login and
// /logout, and nginx 302s those to ${PORTAL_URL}/login and ${PORTAL_URL}/logout
// (the URL lives in the deploy's Coolify env, not the bundle). One image
// deploys to staging and prod; we don't need to know where the portal lives.
// See nginx.conf.template's /login + /logout location blocks.
//
// Local dev: the Vite dev server has no /login proxy. Devs running
// `npm run dev` against staging hit gass-level browser navigation
// hand-off — same-origin from localhost:5173 would fail to redirect.
// For local dev, point window.location at the staging portal directly
// in your devtools, or set up a local nginx in front of the dev server.

// Login bounces back to the page the user was originally trying to reach.
export function loginRedirectUrl(currentHref = window.location.href) {
  return `/login?return_to=${encodeURIComponent(currentHref)}`
}

// Logout always lands back on avatar-web's home (the current deep-link is
// gone post-logout anyway). Calling code shouldn't have to choose between
// "back to where I was" vs "back to home" — pick home for the cleaner UX.
export function logoutRedirectUrl(origin = window.location.origin) {
  return `/logout?return_to=${encodeURIComponent(`${origin}/`)}`
}

export function redirectToLogin() {
  window.location.href = loginRedirectUrl()
}

export function redirectToLogout() {
  window.location.href = logoutRedirectUrl()
}
